module.exports = "/assets/logo_sg_bridge_1_1-05465c6b5bc927f2998e32ddbd792495.png";